/**
 * PrintQuizDescription — 인쇄용 해설 블록 (교사용 정답지)
 * - description.text: substituteVariables(vars) → formatText({image=n} + KaTeX)
 * - description.image/imagePrint: PrintQuizImage로 렌더
 * - hideLabel: "해설" 라벨/패딩 생략 (호출측이 자체 섹션 헤더를 가질 때)
 */
import { formatText } from '../../../utils/quiz-parser'
import { substituteVariables } from '../../../utils/textFormatter'
import { PrintQuizImage, getImageUrl } from './print-common'
import type { DescriptionView } from '../../../types/quizScript'
import type { QuizMediaObject } from '../../../types/legacyQuiz'

const toImg = (c?: { signedUrl?: string | null; url?: string | null } | null) =>
  c ? { signedUrl: c.signedUrl ?? undefined, url: c.url ?? undefined } : null

export function PrintQuizDescription({
  description,
  commentaryImages,
  vars,
  hideLabel,
  compact,
}: {
  description?: DescriptionView | null
  commentaryImages?: QuizMediaObject[] | null
  vars?: Record<string, unknown> | null
  hideLabel?: boolean
  compact?: boolean
}) {
  const rawText = description?.text
  const descImageUrl = getImageUrl(toImg(description?.image), toImg(description?.imagePrint))
  if (!rawText && !descImageUrl) return null

  const text =
    rawText && vars && Object.keys(vars).length > 0
      ? substituteVariables(rawText, vars)
      : rawText

  const body = (
    <>
      {text && (
        <div className={compact ? 'text-[13px] leading-[1.6] text-gray-700' : 'text-[15px] leading-[1.7] text-gray-700'}>
          {formatText(text, 'print-desc', commentaryImages ?? undefined)}
        </div>
      )}
      {descImageUrl && <PrintQuizImage src={descImageUrl} alt="explanation" className="mt-[8px]" />}
    </>
  )

  if (hideLabel) {
    return <div className="break-inside-avoid">{body}</div>
  }

  return (
    <div className="break-inside-avoid mt-[12px] px-[40px]">
      <div className={compact ? 'text-[12px] font-bold text-gray-500 mb-[2px]' : 'text-[14px] font-bold text-gray-500 mb-[4px]'}>
        해설
      </div>
      {body}
    </div>
  )
}
